import { useQuery } from "react-query";
import { getEventMaterials } from "../../../services/api/eventMaterials";
import { EventMaterial, Options, QueryListResult } from "../utils/types";

export const EVENT_MATERIALS_QUERY_KEY = "Q_EVENT_MATERIALS";

export const useEventMaterials = (
  eventId: number,
  materialId: number | undefined,
  options: Options = {}
) => {
  let { page, size, sort, include, enabled, ...rest } = options;

  // todo: extract into generalized option handler for hooks

  if (!page) page = 0;
  if (!size) size = 200;
  if (!sort) sort = "-updated_at";
  if (!include) include = "material";

  const filters: any = {
    "page[number]": page,
    "page[size]": size,
    sort,
    include
  };

  for (const [key, value] of Object.entries(rest)) {
    filters[`filter[${key}]`] = value;
  }

  if (materialId !== undefined) {
    filters["filter[material_id]"] = materialId;
  }

  return useQuery<QueryListResult<EventMaterial>>(
    [EVENT_MATERIALS_QUERY_KEY, eventId, materialId, page, size, sort, include],
    () => getEventMaterials(eventId, filters),
    { keepPreviousData: true, enabled }
  );
};
